<template>
  <div class="user-list">
    <table class="table">
      <thead>
        <tr>
          <th class="text-left" scope="col">Contact</th>
          <th class="text-center" scope="col"></th>
          <th class="text-center" scope="col">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="data in relatedUsers" :key="data.user.id">
          <td class="text-left align-middle">
            <span class="user-name"
              >{{ data.user.firstName }} {{ data.user.lastName }}</span
            ><span class="user-email">{{ data.user.email }}</span>
          </td>
          <td class="user-link-type align-middle">{{ data.relationship }}</td>
          <td class="text-center align-middle">
            <b-button
              variant="primary"
              size="sm"
              class="action-button red"
              @click="sendMessage(data.user.id)"
            >
              <b-icon-envelope-fill class="action-icon"></b-icon-envelope-fill>
              send message
            </b-button>
            <b-button
              v-if="roleMap.Student === data.relationship"
              variant="primary"
              size="sm"
              class="action-button red"
              @click="logInteraction"
            >
              <b-icon-pencil class="action-icon"></b-icon-pencil>
              log interaction
            </b-button>
            <b-button
              variant="primary"
              size="sm"
              class="action-button red"
              @click="viewProfile(data.user)"
            >
              <b-icon-person-fill class="action-icon"></b-icon-person-fill>
              view profile
            </b-button>
            <b-button
              v-if="canEditOtherUsers"
              variant="primary"
              size="sm"
              class="action-button red"
              @click="manageUser(data.user)"
            >
              <b-icon-person-lines-fill
                class="action-icon"
              ></b-icon-person-lines-fill>
              edit user
            </b-button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {
  BIconEnvelopeFill,
  BButton,
  BIconPencil,
  BIconPersonFill,
  BIconPersonLinesFill
} from "bootstrap-vue";
import { RightTrim } from "../lib/Sanitation";

import { RoleMap } from "@/components/lib/Constants";

// TODO this is overlaps with the user-search/UserGrid.vue component. They should be combined to one or share a base.

export default {
  name: "UserListView",
  data: function() {
    return {
      roleMap: RoleMap
    };
  },
  components: {
    BIconEnvelopeFill,
    BIconPersonFill,
    BIconPencil,
    BIconPersonLinesFill,
    BButton
  },
  props: {
    relatedUsers: Array,
    userProfileUrl: { type: String, required: true },
    userAdminUrl: { type: String, required: true },
    canEditOtherUsers: { type: Boolean, default: false },
    logInteractionUrl: { type: String, required: true },
    messageRootUrl: { type: String }
  },
  methods: {
    alert: msg => alert(msg),
    manageUser(user) {
      window.location.href = `${RightTrim("/", this.userAdminUrl)}/${user.id}`;
    },
    viewProfile: function(user) {
      window.location.href = `${RightTrim("/", this.userProfileUrl)}/${
        user.id
      }`;
    },
    logInteraction() {
      window.location.href = `${RightTrim("/", this.logInteractionUrl)}/`;
    },
    sendMessage: function(userId) {
      window.location.href = `${RightTrim(
        "/",
        this.messageRootUrl
      )}/${encodeURIComponent(userId)}`;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.action-icon {
  font-size: 1.5rem;
  margin-right: 0.25rem;
}
.action-button {
  margin: 0.25rem;
}

.user-name {
  font-weight: 600;
}
.user-email {
  font-size: 80%;
  display: block;
}
</style>
